import TagManager from 'react-gtm-module';

export const useClickBookNowTag = ({ label }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_book_now',
      category: 'UI Interaction',
      action: 'Click',
      label
    }
  });

export const useClickBookToGoStripeTag = ({ startDate, endDate, venueId, venueName, typePayment }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_book_to_go_stripe',
      category: 'UI Interaction',
      action: 'Click',
      label: 'Go Stripe Button',
      startDate,
      endDate,
      venueId,
      venueName,
      typePayment
    }
  });

export const useSuccessfulBookingTag = ({ label, venueName }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_successful_booking',
      category: 'UI Interaction',
      action: 'Click',
      label,
      venueName
    }
  });

export const useAbandonedBookingTag = ({ label, venueName }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_abandoned_booking',
      category: 'UI Interaction',
      action: 'Click',
      label,
      venueName
    }
  });
